'use strict';
(()=>{
try {
const root = document.querySelector('[data-cm-dulles-story]');
if (!root) return;
const byId = id => root.querySelector('#' + id);

const activeDialogs = new Map();
root.cmDS = {
 open(dialog, trigger) {
  for (const other of activeDialogs.keys()) if (other !== dialog) { other.close(); root.cmDS.restore(other); }
  if (dialog.open) return;
  const locks = [...new Set([document.body, root.closest('#cm-product-scroll-port')].filter(Boolean))].map(element => ({
   element, value:element.style.getPropertyValue('overflow'), priority:element.style.getPropertyPriority('overflow')
  }));
  activeDialogs.set(dialog,{locks,trigger});
  locks.forEach(({element})=>element.style.setProperty('overflow','hidden'));
  try { dialog.showModal(); } catch(error) { root.cmDS.restore(dialog); throw error; }
 },
 restore(dialog) {
  const saved=activeDialogs.get(dialog); if(!saved)return;
  activeDialogs.delete(dialog);
  saved.locks.forEach(({element,value,priority})=>{
   const style=element.style;
   if(style.getPropertyValue('overflow')==='hidden' && style.getPropertyPriority('overflow')==='') {
    if(value)style.setProperty('overflow',value,priority); else style.removeProperty('overflow');
   }
  });
  if(saved.trigger?.isConnected && !activeDialogs.size)saved.trigger.focus({preventScroll:true});
 }
};
root.addEventListener('close', event=>root.cmDS.restore(event.target),true);
const content=JSON.parse(root.querySelector('[data-cm-ds-content]').textContent);
const sized=(url,width)=>{const source=new URL(url,location.href);source.searchParams.set('width',width);return source.href;};
  const details = Array.isArray(content.details) ? content.details : [];
  if (!details.length) return;
  const dialog = byId('cm-ds-detail-dialog');
  const image = byId('cm-ds-detail-image');
  const strip = byId('cm-ds-detail-thumbnails');
  const cards = byId('cm-ds-detail-cards');
  const mobileGallery = window.matchMedia('(max-width: 749px)');
  let current = 0;

  // Use DOM text nodes so source captions stay complete and cannot become markup.
  function make(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  details.forEach((detail, index) => {
    const thumb = make('button', 'thumbnail-button');
    thumb.type = 'button';
    thumb.setAttribute('aria-label', `ディテール ${index + 1}：${detail.title}`);
    thumb.dataset.index = index;
    const picture = make('img');
    picture.src = sized(detail.image, 96);
    picture.alt = '';
    picture.loading = 'lazy';
    thumb.append(picture);
    thumb.addEventListener('click', () => show(index));
    strip.append(thumb);


  });

  function updateCopy(detail) {
    const title = String(detail.title || '').trim();
    const caption = String(detail.caption || '').trim();
    const hasText = Boolean(caption);
    const titleElement = byId('cm-ds-detail-title');
    const captionElement = byId('cm-ds-dialog-caption');
    titleElement.textContent = title;
    captionElement.textContent = caption;
    titleElement.hidden = true;
    captionElement.hidden = !caption;
    dialog.querySelector('.dialog-copy').hidden = !hasText;
    if (caption) dialog.setAttribute('aria-describedby', 'cm-ds-dialog-caption');
    else dialog.removeAttribute('aria-describedby');
  }

  function show(index) {
    current = ((index % details.length) + details.length) % details.length;
    const detail = details[current];
    resetZoom();
    image.src = detail.image;
    image.width = detail.width;
    image.height = detail.height;
    image.alt = `ナチュラルNUME ダレスバッグ：${detail.title}`;
    byId('cm-ds-detail-number').textContent = `DETAIL ${detail.number}`;
    updateCopy(detail);
    byId('cm-ds-detail-counter').textContent = `${current + 1} / ${details.length}`;
    strip.querySelectorAll('button').forEach((button, position) => {
      button.setAttribute('aria-current', String(position === current));
    });
    const activeThumb = strip.children[current];
    if (activeThumb) {
      const left = activeThumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - activeThumb.clientWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: 'instant' });
    }
  }

  function open(index, trigger) { show(index); root.cmDS.open(dialog, trigger); renderZoom(); byId('cm-ds-detail-close').focus({preventScroll:true}); }
  function close() { if(dialog.open) { dialog.close(); root.cmDS.restore(dialog); } }
  dialog.addEventListener('close',()=>{resetZoom();setThumbnails(false);});
  root.addEventListener('click', event => {
    const trigger = event.target.closest('[data-detail]');
    if (trigger) open(Number(trigger.dataset.detail), trigger);

  });
  byId('cm-ds-detail-close').addEventListener('click', close);
  byId('cm-ds-detail-prev').addEventListener('click', () => show(current - 1));
  byId('cm-ds-detail-next').addEventListener('click', () => show(current + 1));
  dialog.addEventListener('keydown', event => {
    if (['+', '=', '-', '0'].includes(event.key)) {
      event.preventDefault();
      if (event.key === '0') resetZoom();
      else setZoom(zoomScale + (event.key === '-' ? -.5 : .5));
    }
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  // Native dialog supplies Escape dismissal, focus trapping, and background inertness.
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right ||
        event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  const stage = byId('cm-ds-detail-stage');
  const previousButton = byId('cm-ds-detail-prev');
  const nextButton = byId('cm-ds-detail-next');
  previousButton.classList.add('viewer-photo-arrow', 'viewer-photo-arrow--previous');
  nextButton.classList.add('viewer-photo-arrow', 'viewer-photo-arrow--next');
  [previousButton, nextButton].forEach(button => button.addEventListener('pointerdown', event => event.stopPropagation()));
  stage.append(previousButton, nextButton);
  let zoomScale = 1;
  let panX = 0;
  let panY = 0;
  const pointers = new Map();
  let gesture = null;
  let hadPinch = false;
  const zoomButton = make('button', 'viewer-tool', '拡大');
  zoomButton.type = 'button';
  zoomButton.id = 'cm-ds-detail-zoom';
  zoomButton.setAttribute('aria-label', '写真を2倍に拡大');
  zoomButton.setAttribute('aria-pressed', 'false');
  const listButton = make('button', 'viewer-tool viewer-list-toggle', '一覧');
  listButton.type = 'button';
  listButton.setAttribute('aria-controls', 'cm-ds-detail-thumbnails');
  listButton.setAttribute('aria-label', '写真の一覧を表示');
  const controls = dialog.querySelector('.dialog-controls');
  controls.append(zoomButton, listButton);
  const detailCounter = byId('cm-ds-detail-counter');
  zoomButton.addEventListener('pointerdown', event => event.stopPropagation());
  function syncPhotoControls() {
    if (mobileGallery.matches) stage.append(detailCounter, zoomButton);
    else {
      controls.insertBefore(zoomButton, listButton);
      controls.insertBefore(detailCounter, zoomButton);
    }
    renderZoom();
  }
  let desktopThumbnailsVisible = false;
  function setThumbnails(visible) {
    desktopThumbnailsVisible = visible;
    const shown = mobileGallery.matches || visible;
    strip.hidden = !shown;
    dialog.classList.toggle('thumbnails-open', shown);
    listButton.hidden = mobileGallery.matches;
    listButton.setAttribute('aria-expanded', String(shown));
    listButton.setAttribute('aria-label', shown ? '写真の一覧を閉じる' : '写真の一覧を表示');
    syncPhotoControls();
  }
  mobileGallery.addEventListener('change', () => setThumbnails(desktopThumbnailsVisible));
  setThumbnails(false);
  listButton.addEventListener('click', () => setThumbnails(strip.hidden));
  function clampPan(value, scaledSize, viewportSize) {
    const limit = Math.max(0, (scaledSize - viewportSize) / 2);
    return Math.max(-limit, Math.min(limit, value));
  }
  function renderZoom() {
    if (mobileGallery.matches) {
      const insetX = Math.max(0, (stage.clientWidth - image.offsetWidth) / 2) + 10;
      const insetY = Math.max(0, (stage.clientHeight - image.offsetHeight) / 2) + 10;
      detailCounter.style.left = `${insetX}px`;
      detailCounter.style.top = `${insetY}px`;
      zoomButton.style.right = `${insetX}px`;
      zoomButton.style.bottom = `${insetY}px`;
    } else {
      detailCounter.style.left = detailCounter.style.top = '';
      zoomButton.style.right = zoomButton.style.bottom = '';
    }
    const arrowInset = Math.max(0, (stage.clientWidth - image.offsetWidth) / 2) + 10;
    previousButton.style.left = `${arrowInset}px`;
    nextButton.style.right = `${arrowInset}px`;
    panX = clampPan(panX, image.offsetWidth * zoomScale, stage.clientWidth);
    panY = clampPan(panY, image.offsetHeight * zoomScale, stage.clientHeight);
    image.style.transform = `translate(${panX}px, ${panY}px) scale(${zoomScale})`;
    stage.classList.toggle('is-zoomed', zoomScale > 1);
    zoomButton.textContent = zoomScale > 1 ? '全体' : '拡大';
    zoomButton.setAttribute('aria-pressed', String(zoomScale > 1));
    zoomButton.setAttribute('aria-label', zoomScale > 1 ? '写真を全体表示に戻す' : '写真を2倍に拡大');
  }
  function setZoom(value) {
    zoomScale = Math.max(1, Math.min(4, value));
    if (zoomScale === 1) panX = panY = 0;
    renderZoom();
  }
  function resetZoom() {
    zoomScale = 1;
    panX = panY = 0;
    pointers.clear();
    gesture = null;
    hadPinch = false;
    renderZoom();
  }
  function toggleZoom() { setZoom(zoomScale > 1 ? 1 : 2); }
  zoomButton.addEventListener('click', toggleZoom);
  image.addEventListener('load', renderZoom);
  new ResizeObserver(renderZoom).observe(stage);
  stage.style.touchAction = 'none';
  stage.setAttribute('aria-label', '写真。全体表示では左右スワイプで写真を切り替え、クリックまたはタップで拡大。拡大中はドラッグで移動');
  image.draggable = false;
  stage.addEventListener('dragstart', event => event.preventDefault());
  function startGesture() {
    const points = [...pointers.values()];
    if (points.length >= 2) {
      hadPinch = true;
      gesture = { distance: Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y), scale: zoomScale };
    } else if (points.length === 1) {
      gesture = { x: points[0].x, y: points[0].y, panX, panY, scale: zoomScale, moved: false };
    } else gesture = null;
  }
  stage.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    if (pointers.size === 0) hadPinch = false;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    stage.setPointerCapture(event.pointerId);
    startGesture();
  });
  stage.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId) || !gesture) return;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    const points = [...pointers.values()];
    if (points.length >= 2) {
      const distance = Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
      setZoom(gesture.scale * distance / Math.max(1, gesture.distance));
    } else {
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (Math.hypot(dx, dy) > 6) gesture.moved = true;
      if (zoomScale > 1) {
        panX = gesture.panX + dx;
        panY = gesture.panY + dy;
        renderZoom();
      }
    }
  });
  stage.addEventListener('pointerup', event => {
    if (!pointers.has(event.pointerId)) return;
    const previous = gesture;
    const single = pointers.size === 1 && !hadPinch && previous;
    pointers.delete(event.pointerId);
    if (single) {
      const dx = event.clientX - previous.x;
      const dy = event.clientY - previous.y;
      if (previous.scale === 1 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) {
        show(current + (dx < 0 ? 1 : -1));
      } else if (!previous.moved && Math.hypot(dx, dy) < 6) toggleZoom();
    }
    startGesture();
  });
  function cancelPointer(event) {
    pointers.delete(event.pointerId);
    hadPinch = true;
    startGesture();
  }
  stage.addEventListener('pointercancel', cancelPointer);
  stage.addEventListener('lostpointercapture', event => {
    if (pointers.has(event.pointerId)) cancelPointer(event);
  });


} catch(error) { console.error("Dulles detail: " ,error); }
})();
